/* eslint-disable arrow-body-style */
import React from 'react';
import { Layout } from 'tea-component';
import useSetQueryDefinition from '@intelligence/hooks/useQueryDefinition';

const { Body } = Layout;

export default (props: any) => {
  useSetQueryDefinition({
    homeSearchCfg: {
      target: 'game_config',
      params: {
        key: 'home_game_search_*',
      },
    },
  });

  return (
    <>
      {/* <Header className="layout__header">*/}
      {/*  <NavHader />*/}
      {/* </Header>*/}
      <Body className="layout__body">{props.children}</Body>
    </>
  );
};
